module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    style: ({
      height: _vm.chart_height
    }),
    attrs: {
      "id": "canvas-feemarket"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-423f8bdd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/feemarket.vue
// module id = 539
// module chunks = 1